/** Format a fractional fee-discount rate (e.g. 0.15) as a whole percentage ("15%"). */
export function formatPercentage(rate: number): string {
  return `${Math.round(rate * 100)}%`;
}

/** Format an amount in cents as a locale-aware, whole-dollar currency string. */
export function formatCurrency(cents: number, currency: string): string {
  return new Intl.NumberFormat(navigator.language, {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(cents / 100);
}

/**
 * Format the offer's expiry timestamp as a locale-aware short month/day (e.g. "Aug 3").
 * Uses the actual `expiresAt` date so the subtitle always shows the real deadline.
 */
export function formatExpiryDate(expiresAt: string): string {
  return new Intl.DateTimeFormat(navigator.language, {
    month: 'short',
    day: 'numeric',
  }).format(new Date(expiresAt));
}
